module.exports = __webpack_public_path__ + "static/media/trackandfieldscorebook.e40a8510.png";